import * as React from "react";
import { useNavigate } from "react-router-dom";
import { TemplateSub } from "../../../components/layouts/TemplateSub";
import ChangeEmail from "../../../assets/profile/change-email.svg";
import ChangePhoneNo from "../../../assets/profile/change-phone.svg";
import ChangePassword from "../../../assets/profile/change-password.svg";
import ChangePin from "../../../assets/profile/change-pin.svg";
import CloseAccount from "../../../assets/profile/close-account.svg";
import * as ROUTES from "../../../constants/routes";

export const AccountDetailPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <TemplateSub page="Account Details">
      <div className="px-4">
        <div className="flex flex-col gap-[18px] mt-[8px] w-full">
          <button
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg"
            onClick={() => navigate(ROUTES.CHANGE_EMAIL_DETAILS)}
          >
            <img src={ChangeEmail} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Change Email Address</p>
          </button>
          <button
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg"
            onClick={() => navigate(ROUTES.CHANGE_PHONE_NUMBER)}
          >
            <img src={ChangePhoneNo} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Change Phone Number</p>
          </button>
          <button
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg"
            onClick={() => navigate(ROUTES.CHANGE_PASSWORD_PROFILE)}
          >
            <img src={ChangePassword} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Change Password</p>
          </button>
          <button
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg"
            onClick={() => navigate(ROUTES.CHANGE_PIN)}
          >
            <img src={ChangePin} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Change PIN</p>
          </button>
          <button
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg"
            onClick={() => navigate(ROUTES.CLOSE_ACCOUNT)}
          >
            <img src={CloseAccount} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Close Account</p>
          </button>
        </div>
      </div>
    </TemplateSub>
  );
};